var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
// Utils
import { isPrimitive } from '../../others';
import { getArrayOfValuesFromObject } from '../getArrayOfValuesFromObject';
/**
 * @description Collect values at path specified from nestable object (ex.invoice_lines) recursively and return results as array
 *
 * @param {object} obj
 * @param {string} nestedProperty
 * @param {string[]} keyToFind
 * @param {PathArray} targetPathArray
 *
 * @example
 *
 * getArrayOfNestedPropertyValuesRecursively({id: 1, nestable:{id: 2, key: 5, nestable:{id: 3}}]}, 'nestable', ['id', 'key']);
 * // return [{ id: 2, key: 5 }, { id: 3 }]
 *
 * getArrayOfNestedPropertyValuesRecursively({id: 1, nestable:{id: 2, object: { key: 1 } ]}, 'nestable', ['key'], 'object');
 * // return [{ key: 1 }]
 *
 * getArrayOfNestedPropertyValuesRecursively(
 *   {
 *     nestable: [
 *       {id: 1, nestable: [{id: 11}]},
 *       {id: 2, nestable: [{id: 21}, {id: 11}]},
 *       {id: 3},
 *       {id: 4, nestable: [{id: 41, nestable: [{id: 441}]}]},
 *     ]
 *   },
 *   'nestable',
 *   ['id']
 * );
 * // return [{ id: 1 }, { id: 11 },{ id: 2 }, { id: 21 }, { id: 11 }, { id: 3 }, { id: 4} , { id: 41 }, { id: 441 }]
 *
 * @return {any[]}
 */
export var getArrayOfNestedPropertyValuesRecursively = function (obj, nestedProperty, keyToFind, targetPathArray) {
    if (targetPathArray === void 0) { targetPathArray = []; }
    if (isPrimitive(obj)) {
        return [];
    }
    if (Array.isArray(obj)) {
        // Go deeper to each object
        return obj.reduce(function (resultArray, currentObj) { return __spread(resultArray, getArrayOfNestedPropertyValuesRecursively(currentObj, nestedProperty, keyToFind, targetPathArray)); }, []);
    }
    // Get target values from current object
    var valuesArray = getArrayOfValuesFromObject(obj, keyToFind, targetPathArray);
    // If the object have another nested object, go deeper
    if (obj[nestedProperty]) {
        valuesArray = valuesArray.concat(getArrayOfNestedPropertyValuesRecursively(obj[nestedProperty], nestedProperty, keyToFind, targetPathArray));
    }
    return valuesArray;
};
//# sourceMappingURL=getArrayOfNestedPropertyValuesRecursively.js.map